module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAYAAACXDi8zAAAAZElEQVQYV2NkgIKGtllqIGZDVdotEM0IIirapwmy/PofBGL/YWNc11GZ9Z6xoaGB5ReTeBATI4MgSOLff4b3bP9ermOsapzqyMTEBDYGBv79+3cLbBQ2gFsCp1E4LcfpXFweBAA58TS1X5tjPwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/market-sort.png
// module id = ua1v
// module chunks = 6